import { bulkSignOrchestratorApi } from "@rshbintech.dboul/http";
import { Dispatch, SetStateAction } from "react";
import { TASK_STATUS } from "../constants";

export const getIsTaskFinished = async (
  taskId: string,
  setError: Dispatch<SetStateAction<string>>
) => {
  const signTaskStatusResponse =
    await bulkSignOrchestratorApi.api.getSignTaskStatus(taskId);

  const { state: taskStatus, errorText: errorText } =
    signTaskStatusResponse.data;

  if (errorText) {
    setError(errorText);

    return;
  }

  return taskStatus === TASK_STATUS.FINISHED;
};
